import appNavigationController from '@components/appNavigationController';

import {CURRENT_ACCOUNT_QUERY_PARAM} from '@lib/accounts/constants';
import {ActiveAccountNumber} from '@lib/accounts/types';

export type ChangeAccountOptions = {
  newTab?: boolean,
  preserveHash?: boolean,
  /**
   * Full document navigation via location.assign — skips appNavigationController.reload
   * (Navigation API modificationQueue / spliceItems). Used by Messario launch slot switch.
   */
  hardNavigate?: boolean
};

export function changeAccount(
  accountNumber: ActiveAccountNumber,
  newTab?: boolean,
  preserveHash?: boolean
): void;
export function changeAccount(
  accountNumber: ActiveAccountNumber,
  options: ChangeAccountOptions
): void;
export function changeAccount(
  accountNumber: ActiveAccountNumber,
  newTabOrOptions: boolean | ChangeAccountOptions = false,
  preserveHash?: boolean
) {
  const options: ChangeAccountOptions = typeof newTabOrOptions === 'object' ?
    newTabOrOptions :
    {newTab: newTabOrOptions, preserveHash};

  const url = new URL(location.href);

  if(accountNumber === 1) url.searchParams.delete(CURRENT_ACCOUNT_QUERY_PARAM);
  else url.searchParams.set(CURRENT_ACCOUNT_QUERY_PARAM, accountNumber + '');

  if(!options.preserveHash) url.hash = '';

  if(options.newTab) {
    window.open(url, '_blank');
  } else if(options.hardNavigate) {
    location.assign(url.href);
  } else {
    appNavigationController.reload(url);
  }
}
